import { useQuery } from '@tanstack/react-query'
import { attendeeApi } from '@/api/attendee'
import { certificateDownloadUrl } from '@/api/public'
import { Award, Download } from 'lucide-react'
import { useAttendeeDates } from '@/hooks/useDates'

export default function AttendeeCertificatesPage() {
  const { formatDate } = useAttendeeDates()
  const fmtDate = (iso: string) => {
    return formatDate(iso, { day: 'numeric', month: 'short', year: 'numeric' })
  }
  const { data: certs = [], isLoading } = useQuery({
    queryKey: ['attendee-certificates'],
    queryFn: () => attendeeApi.getCertificates().then(r => r.data),
  })

  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-slate-900">Your certificates</h1>
      {isLoading ? (
        <p className="text-sm text-slate-400">Loading…</p>
      ) : certs.length === 0 ? (
        <p className="text-sm text-slate-400">No certificates yet. They'll appear here once issued.</p>
      ) : (
        <div className="space-y-3">
          {certs.map(c => (
            <div key={c.certificateId} className="bg-white border border-slate-200 rounded-xl p-4 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center shrink-0">
                  <Award size={18} className="text-indigo-500" />
                </div>
                <div>
                  <p className="font-medium text-slate-900">{c.courseName}</p>
                  <p className="text-xs text-slate-400">Issued {fmtDate(c.issuedAt)}</p>
                </div>
              </div>
              <a
                href={certificateDownloadUrl(c.certificateId)}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-1.5 text-sm font-medium text-indigo-600 hover:text-indigo-800"
              >
                <Download size={15} /> Download
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
